import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { SelectionModel } from '@angular/cdk/collections';
import { DatePipe } from '@angular/common';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { CustomerService } from '../_services/customer.service';
import { DebtorService } from '../_services/debtor.service';
import { MatSort, MatPaginator, MatTableDataSource } from '@angular/material';
import { AppConfig, ExcelService } from '../_helpers/index';

import { ParameterData } from '../_helpers/index';
import { Router } from '@angular/router';
import { accountStatus, accountType } from '../_enums/account';
import { DataService } from '../_helpers/dataservice.service'
import { Account } from '../_models';
import { AuthService } from '../_services/auth.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';


@Component({
  selector: 'accountslist',
  templateUrl: './accountslist.component.html',
  styleUrls: ['../../assets/css/customer-list-table.css']
})

export class AccountsListComponent implements OnInit, OnDestroy {

  public customer_public_id: string;

  excelExportData: any;
  ddlStatus: any[];
  ddlAccountType: any[];

  searchFilterForm: FormGroup;
  searchRangoFilterForm: FormGroup;
  displayedColumns: string[] = ['type', 'name', 'description', 'balance.currency', 'balance.value', 'status'];
  dataSourceAccountsList = new MatTableDataSource();
  selection = new SelectionModel<any>(true, []);
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  filterValue;
  customerPublic_key;
  isRangoVisiable = false;
  auth0Profile: any;
  isLoading = true;
  pageSize: number;
  PageSizeOptions: number[];
  public customersCompanyDetailsList: any;
  public customersCompanyType: any;
  isReadAvailable = true;
  /** This is Constructor function which is used to initialize the class variables and objects; 
   */
  constructor
    (
      private router: Router, private formBuilder: FormBuilder, private _fb: FormBuilder, private excelService: ExcelService
      , private parameterData: ParameterData, private dataService: DataService
      , private customerService: CustomerService, private debtorService: DebtorService
      , private status: accountStatus
      , private acctype: accountType
      , private datePipe: DatePipe
      , private auth: AuthService
      , private spinnerService: Ng4LoadingSpinnerService
    ) {


    this.pageSize = AppConfig.settings.gridPageSetting.PageSize;
    this.PageSizeOptions = AppConfig.settings.gridPageSetting.PageSizeOptions;



    this.ddlStatus = status._status;
    this.ddlAccountType = acctype._accountType;


  }//end 


  /** This is ngOnInit function called after initialising the component; 
 */
  ngOnInit() {

    this.spinnerService.show();
    this.checkThisPageGrants();
    let browserStorage1 = (localStorage.getItem('isCorporate') == 'undefined') ? null : localStorage;
    if (browserStorage1 == null) {
      let browserStorage = localStorage.getItem('companyId');
      if (browserStorage == null || browserStorage == '' || browserStorage == undefined) {
        this.router.navigate(['/home']);
      }
      else {
        this.customer_public_id = localStorage.getItem('companyId');

      }
    }
    else {
      this.customer_public_id = localStorage.getItem('subcompanyId');

    }


    this.searchFilterForm = this.formBuilder.group({
      searchText: ['', Validators.required]
    });

    this.paginator._intl.itemsPerPageLabel = "Registros por página";
    this.paginator._intl.nextPageLabel = "siguiente página";
    this.paginator._intl.lastPageLabel = "última página";
    this.paginator._intl.previousPageLabel = "anterior página";
    this.paginator._intl.firstPageLabel = "primera página";
    this.GetCustomersCompanyList();
    // this.GetCustomerAccountsList();
    this.dataSourceAccountsList.paginator = this.paginator;
    //this.dataSourceAccountsList.sort = this.sort;

  }//end

  ngOnDestroy() {

  }//end


  getProperty = (obj, path) => (
    path.split('.').reduce((o, p) => o && o[p], obj)
  )

  ngAfterViewInit(){
    this.dataSourceAccountsList.sortingDataAccessor = (obj, property) => this.getProperty(obj, property);
    this.dataSourceAccountsList.sort = this.sort;
  }
  /*Get Customers Company List*/
  GetCustomersCompanyList() {
    this.customerService.getCustomerCompanyDetailsList(this.customer_public_id).subscribe(d => {
      let resources = d;
      this.customersCompanyDetailsList = resources;
      let results = d.body.type;
      this.customersCompanyType = results;
      this.GetCustomerAccountsList();
    });
  }


  /** This function is used to get the invoices list from the service; 
 * it accepts the param customerId
 */
  GetCustomerAccountsList() {


    setTimeout(() => {
      this.customerService.getCustomerAccountList(this.customer_public_id, '').subscribe(data => {
        let resources = data;


        if (this.customersCompanyType == 'COMPANY') {

          this.dataSourceAccountsList.data = data.filter(item => item.type == 'SETTLEMENT' || item.type == 'COLLECT');

        }
        else if (this.customersCompanyType == 'COMPANY_PAYOUT' || this.customersCompanyType == 'PSP_PAYOUT') {

          this.dataSourceAccountsList.data = data.filter(item => item.type != 'RECEIVABLE' && item.type != 'PAYABLE');

        }
        else {
          this.dataSourceAccountsList.data = data.filter(item => item.type == 'VIRTUAL' || item.type == 'BANK' || item.type == 'PSP');
        }
        this.spinnerService.hide();
        this.excelExportData = resources;
      },
        error => {
          console.log('Failed! while trying to get the accounts list. ' + error);
        });

    }, 0);




  }//end


  /* 
        * This function is used to work the text filter above the grid; 
       */
  applyFilter() {

    this.filterValue = this.searchFilterForm.controls.searchText.value;
    this.filterValue = this.filterValue.trim();
    this.filterValue = this.filterValue.toLowerCase();
    this.dataSourceAccountsList.filter = this.filterValue;



  }//end

  /** This function is used to filter the Account list based on Type wise; 
   * it accepts the param select status value
   */
  filterAccountDetails(accounttype) {

    if (accounttype == this.ddlAccountType[0].value) {
      this.dataSourceAccountsList.filter = '';
    }
    else {
      this.dataSourceAccountsList.filter = '';
      this.dataSourceAccountsList.filterPredicate = (data: Account, filter: string) =>
        data.type == accounttype;
      this.dataSourceAccountsList.filter = accounttype;
    }



  }//end


  /** This function is used to filter the Account list based on Status wise; 
   * it accepts the param select status value
   */
  filterStatusDetails(status) {

    if (status == this.ddlStatus[0].value) {
      this.dataSourceAccountsList.filter = '';
    }
    else if (status == 'ACTIVE') {
      this.dataSourceAccountsList.filter = '';
      this.dataSourceAccountsList.filterPredicate = (data: Account, filter: string) =>
        data.status == 'ACTIVE';
      this.dataSourceAccountsList.filter = 'ACTIVE';
    }
    else if (status == 'INACTIVE') {
      this.dataSourceAccountsList.filter = '';
      this.dataSourceAccountsList.filterPredicate = (data: Account, filter: string) =>
        data.status == 'INACTIVE';
      this.dataSourceAccountsList.filter = 'INACTIVE';
    }



  }//end

  async checkThisPageGrants() {
    await this.auth.isKashioGrantsAvailable();
    this.isReadAvailable = this.auth.checkGrants('ACCOUNTS','READ');
 }
}//end class


